/**
 *
 * @description: 上海东方证券资产管理有限公司
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'dfzq';
const comein_channel = isBuild ? '1e79547a-b594-4645-9cf4-3e66a84b8990' : '';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'dfzq';

// 东方证券Bridge类 - 使用默认实现，空的empowerAlert函数
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false, () => {}); // 传递空的empowerAlert函数
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
